import NavFocus, { NavFocusAction } from "@/nav/nav.focus"
import { SessionDashboardTab } from "@/redux/_session.types"
import { faLocationDot, faUserFriends, faTriangleExclamation, faHeart } from "@fortawesome/free-solid-svg-icons"
import { useLocation, useNavigate } from "react-router-dom"
import { useRisksSpace } from "@/core/risks-space.context"
import { PhysicalRiskSelectionActions, PhysicalRiskSelectionProvider } from "@/entities/physical-risk/ui/PhysicalRiskSelection"

interface Props {
  children: React.ReactNode
  actions?: Array<
    NavFocusAction & {
      onClick: () => void
    }
  >
  onTabClick?: () => void
}

/** Onglets de la section "Risques". Declares ici uniquement : le menu global les reprend en sous-menu. */
export const ESTABLISHMENT_TABS: SessionDashboardTab[] = [
  {
    id: "/risks/phy",
    label: "Risques physiques",
    icon: faTriangleExclamation
  },
  {
    id: "/risks/rps",
    label: "Risques psychosociaux",
    icon: faHeart
  },
  {
    id: "/risks/populations",
    label: "Fonctions",
    icon: faUserFriends
  },
  {
    id: "/risks/sites",
    label: "Lieux de travail",
    icon: faLocationDot
  }
]

export default function NavEstablishment({ children, actions = [], onTabClick }: Props) {
  const location = useLocation()
  const navigate = useNavigate()
  const { isReadonly } = useRisksSpace()
  const isRootTab = ESTABLISHMENT_TABS.some((tab) => tab.id === location.pathname)

  function handleAction(actionId: string) {
    const action = actions.find((item) => item.id === actionId)
    if (action) {
      action.onClick()
      return
    }

    onTabClick?.()
    navigate(actionId)
  }

  function handleBack() {
    if (isRootTab) {
      navigate("/home")
    } else {
      navigate(-1)
    }
  }

  //En lecture seule (document unique), la page porte son propre bandeau : ni onglets ni actions.
  if (isReadonly) return <>{children}</>

  return (
    <PhysicalRiskSelectionProvider key={location.pathname}>
      <NavFocus
        tabs={ESTABLISHMENT_TABS}
        actions={actions}
        customActions={<PhysicalRiskSelectionActions />}
        onBack={handleBack}
        onAction={handleAction}>
        {children}
      </NavFocus>
    </PhysicalRiskSelectionProvider>
  )
}
